import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-imprint',
  templateUrl: './privacy-imprint.component.html',
  styleUrls: ['./privacy-imprint.component.scss'],
})
export class PrivacyImprintComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
